import type { MessageAttachment } from '@/types/conversations'
import { resolveAttachmentMediaUrl } from '@/lib/resolveAttachmentMediaUrl'

import type { AttachmentContext } from './attachmentContext'

interface VideoAttachmentProps {
  attachment: MessageAttachment
  attachmentContext?: AttachmentContext
}

export function VideoAttachment({
  attachment,
  attachmentContext = 'assistant',
}: VideoAttachmentProps) {
  const src = resolveAttachmentMediaUrl(attachment.file_url)
  if (!src) {
    return null
  }

  const showAiDescription =
    attachmentContext === 'assistant' && Boolean(attachment.ai_description?.trim())

  return (
    <div className="flex w-full max-w-[min(100%,280px)] flex-col gap-1">
      <video controls src={src} className="max-h-72 w-full rounded-md border" />
      {showAiDescription ? (
        <p className="text-xs italic text-muted-foreground">🎬 {attachment.ai_description}</p>
      ) : null}
    </div>
  )
}
